// extracted by mini-css-extract-plugin
module.exports = {"spinnerPrimary":"Loader_spinnerPrimary__kso7G"};